import { AxiosResponse } from 'axios';
import cacheableRequest from '../../../services/cacheableRequest';
import { TrainingItem } from '../models/trainingItem';

export const getTrainingItem = (trainingId: string): Promise<TrainingItem> => {
  return cacheableRequest(`/v1/training/${trainingId}`).then(({ data }: AxiosResponse<{ training: TrainingItem }>) => {
    return data;
  });
};
